import { render, staticRenderFns } from "./SearchCardLayout.vue?vue&type=template&id=10285682&scoped=true"
import script from "./SearchCardLayout.vue?vue&type=script&lang=js"
export * from "./SearchCardLayout.vue?vue&type=script&lang=js"
import style0 from "./SearchCardLayout.vue?vue&type=style&index=0&id=10285682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10285682",
  null
  
)

export default component.exports